/* eslint-disable complexity */
/* eslint-disable max-statements */
import React, { useState, useEffect, useRef } from "react";
import styles from "./styles.css";
import Search from "../../shared/search";
import PropTypes from "prop-types";
// import graph from "./images/graph.png";
// import getCarInfo from "../../../utils/helpers/get-car-info";
import { makePriceLabelRound } from "../../../utils/helpers/make-price-label";
// import { useHistory } from "react-router-dom";
import { DEFAULT_REPAYMENT_TENURE, FINANCE_TNC_LINK, NUMBER } from "../../../constants/app-constants";
import { floor } from "lodash";
import debounce from "../../../utils/helpers/debounce";
import { calculateEmiAUV2 } from "../../../utils/helpers/calculate-emi";
import InputText from "../../shared/input-text";
import Slider from "../../shared/slider";
import GuageChart from "../gauge-chart/component";
import DropDown from "./images/dropdown-arrow.svg";
import withCallbackRequest from "../with-callback-request";
import { getPreApprovedAmount } from "../../../utils/helpers/get-pre-approved-amount";
import { BOOL_STATE } from "../../../constants/checkout-constants";
import SuccessIcon from "./images/success.svg";
import WarningIcon from "./images/warning.svg";
import { useHistory } from "react-router";
import ArrowRight from "./images/arrow-right.svg";
import { trackDesktopCustomEventsAU } from "../../../tracking";
import { AU_DESKTOP_EVENTS } from "../../../tracking/au.desktop-events";
import Button from "../../shared/button";
import { getAbExpirementVariant } from "../../../utils/helpers/get-ab-expirement-variant";
import { EXPERIMENT_TYPE } from "../../../constants/optimize-constants";

const DEFAULT_TENURE = [
    {
        label: "3",
        value: 3
    },
    {
        label: "4",
        value: 4
    },
    {
        label: "5",
        value: 5
    },
    {
        label: "7",
        value: 7
    }
];
const REPAYMENT_TENURE_TABS = [
    {
        key: "WEEKLY",
        label: "Weekly",
        shorthand: "week"
    },
    {
        key: "FORTNIGHTLY",
        label: "Fortnightly",
        shorthand: "fortnight"
    },
    {
        key: "MONTHLY",
        label: "Monthly",
        shorthand: "month"
    }
];

const FINANCE_CALCULATOR = {
    DAP: "dap",
    DEPOSIT: "deposit",
    INTEREST: "interest"
};
const defaultSliderProps = {
    mode: 1,
    tickCount: 10,
    railColor: "#D9E6F1",
    disabledTrackStyles: {
        backgroundColor: "#0071BC",
        backgroundImage: "linear-gradient(269deg, #0071BC, #0071BC)"
    },
    // hideTicksOnEdges: false,Car's Drive Away Price
    handleColor: "white"
};
const onCalculatorUsed = () => {};
const calculatorUseddebounced = debounce(onCalculatorUsed, NUMBER.THOUSAND);

const CdpLoanCalculator = ({ content, preApproved, minMaxInterestRateInfo, getMinMaxInterestRatesConnect, loanCalculatorInfo, maxPermissibleRepaymentPerWeek, isPurposeBusiness,
    startPreApprovalOnFlyConnect, preApprovalOnFlyDesktop
}) => {
    const { estimatedPrice = 0, emiDetails, personalised } = content || {};
    // const {isStEligible = false} = stEligibleData || {};
    const {
        interestRate,
        lenderFee,
        balloonPercentage,
        lenderMonthlyFee,
        tenure: defaultTenure
    } = emiDetails || {};
    // const history = useHistory();
    const onBlurRef = useRef();
    // updates input value as user enters
    const { minInterestRate, maxInterestRate } = minMaxInterestRateInfo || {};
    const { interestRate: apiInterestRate } = loanCalculatorInfo || {};
    const finalInterestRate = personalised ? interestRate : apiInterestRate;
    const minRate = floor(minInterestRate, 1) || 0;
    const maxRate = floor(maxInterestRate, 1) || 1;
    const [repaymentSI, setRepaymentSI] = useState({
        WEEKLY: 0,
        FORTNIGHTLY: 0,
        MONTHLY: 0
    });
    const history = useHistory();
    const [totalAmountPaid, setTotalAmountPaid] = useState({ WEEKLY: 0, MONTHLY: 0, FORTNIGHTLY: 0 });

    const [graphPercentage, setGraphPercentage] = useState(NUMBER.FIFTY);

    const [activeTab, setActiveTab] = useState({key: "WEEKLY", label: "Weekly", shorthand: "week"});
    const [inputParameters, setInputParameters] = useState({
        dap: +estimatedPrice <= NUMBER.FIVE_THOUSAND_FIVE_HUNDRED ? NUMBER.FIVE_THOUSAND_FIVE_HUNDRED : estimatedPrice,
        deposit: NUMBER.FIVE_HUNDRED,
        loanTenure: defaultTenure,
        interestRate: finalInterestRate
    });
        // holds final value to display on loan summary card
    const [priceState, setPriceState] = useState({
        dap: +estimatedPrice <= NUMBER.FIVE_THOUSAND_FIVE_HUNDRED ? NUMBER.FIVE_THOUSAND_FIVE_HUNDRED : estimatedPrice,
        deposit: NUMBER.FIVE_HUNDRED,
        interestRate: finalInterestRate,
        loanTenure: defaultTenure
    });
    const [loanDetailsAccordion, setLoanDetailsAccordion] = useState(false);
    const totalLoanAmount = priceState.dap - priceState.deposit;

    const generateGraphValues = () => {
        const percentage = (totalLoanAmount / parseInt(totalAmountPaid[activeTab.key])) * NUMBER.HUNDRED;
        setGraphPercentage(percentage);
    };
    // eslint-disable-next-line max-params
    const handleSI = ({ dap,
        interestRate: rate,
        loanTenure, deposit }) => {
        // const emiValue = calculateEmiAUV2({ loanAmount: dap - deposit, lenderFee, balloonPercentage, lenderMonthlyFee, interestRate: rate, tenure: (loanTenure) * NUMBER.FIFTY_TWO });
        // setSimpleInterest(emiValue);
        const computedValues = { si: {}, totalAmountPaid: {} };
        Object.keys(DEFAULT_REPAYMENT_TENURE).forEach((t) => {
            const currentTenure = parseInt(loanTenure) * DEFAULT_REPAYMENT_TENURE[t];

            const si = calculateEmiAUV2({
                loanAmount: dap - deposit,
                lenderFee,
                balloonPercentage,
                lenderMonthlyFee,
                interestRate: rate,
                tenure: currentTenure,
                periodsInAYear: DEFAULT_REPAYMENT_TENURE[t]
            });

            const total = si * currentTenure;
            computedValues.si[t] = si;
            computedValues.totalAmountPaid[t] = total;
        });
        setRepaymentSI({
            ...computedValues.si
        });
        setTotalAmountPaid({
            ...computedValues.totalAmountPaid
        });
    };
    const showStrip = preApproved && isPurposeBusiness === BOOL_STATE.NO;
    const isWithinLimit = maxPermissibleRepaymentPerWeek && repaymentSI[activeTab.key] <= maxPermissibleRepaymentPerWeek;

    useEffect(() => {
        generateGraphValues();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [totalAmountPaid[activeTab.key]]);

    const interestSlider = {
        domain: [minRate, maxRate],
        defaultValues: [priceState.interestRate],
        step: 0.25,
        onUpdate: (values) => {
            calculatorUseddebounced();
            const value = values[0];
            const updatedValue = onBlurRef.current ? priceState : { ...priceState, interestRate: value };
            onBlurRef.current = false;
            setInputParameters(updatedValue);
            setPriceState(updatedValue);
            handleSI(updatedValue);
        },

        ...defaultSliderProps
    };

    useEffect(() => {
        //refect after logout resets the preapproval state
        if (!minInterestRate) {
            getMinMaxInterestRatesConnect();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [minInterestRate]);
    useEffect(() => {
        setPriceState({...inputParameters, interestRate: finalInterestRate});
        setPriceState({...priceState, interestRate: finalInterestRate});
        handleSI(inputParameters);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [finalInterestRate]);
    const onChange = (key, e) => {
        const inputValue = e.target.value;
        switch (key) {
        case FINANCE_CALCULATOR.DAP: {
            return setInputParameters({ ...inputParameters, dap: +inputValue });
        }
        case FINANCE_CALCULATOR.DEPOSIT: {
            return setInputParameters({ ...inputParameters, deposit: +inputValue });
        }
        case FINANCE_CALCULATOR.INTEREST: {
            const sanitizedInput = inputValue.replace(/[^0-9.]+/, "");
            return setInputParameters({ ...inputParameters, interestRate: sanitizedInput });
        }
        default:
            return { ...inputParameters };
        }
    };
    const getInterestRate = (interestRateValue) => {
        if (interestRateValue < minInterestRate) {
            return minInterestRate;
        } else if (interestRateValue > maxInterestRate) {
            return maxInterestRate;
        } else {
            return interestRateValue;
        }
    };

    const onBlurInput = (value, key) => {
        const inputValue = +value;
        const minPrice = NUMBER.FIVE_THOUSAND_FIVE_HUNDRED;
        const minDeposit = NUMBER.FIVE_HUNDRED;

        switch (key) {
        case FINANCE_CALCULATOR.DAP: {
            const updatedPrice = inputValue < minPrice ? minPrice : inputValue;
            const updatedDeposit =
                        updatedPrice - inputParameters.deposit < NUMBER.FIVE_HUNDRED
                            ? NUMBER.FIVE_HUNDRED
                            : inputParameters.deposit;
            setPriceState({ ...priceState, dap: updatedPrice, deposit: updatedDeposit });
            setInputParameters({ ...inputParameters, dap: updatedPrice, deposit: updatedDeposit });
            handleSI({...inputParameters, dap: updatedPrice, deposit: updatedDeposit});
            return;
        }
        case FINANCE_CALCULATOR.DEPOSIT: {
            const updatedInputValue = inputValue < minDeposit ? minDeposit : inputValue;
            const updatedDeposit =
                        updatedInputValue > inputParameters.dap ||
                            inputParameters.dap - updatedInputValue < NUMBER.FIVE_THOUSAND
                            ? inputParameters.dap - NUMBER.FIVE_THOUSAND
                            : updatedInputValue;
            setPriceState({ ...priceState, deposit: updatedDeposit });
            setInputParameters({ ...inputParameters, deposit: updatedDeposit });
            handleSI({...inputParameters, deposit: updatedDeposit});
            return;
        }
        case FINANCE_CALCULATOR.INTEREST: {
            const updatedInterestRate = getInterestRate(inputValue);
            setPriceState({ ...priceState, interestRate: updatedInterestRate });
            setInputParameters({ ...inputParameters, interestRate: updatedInterestRate });
            handleSI({...inputParameters, interestRate: updatedInterestRate});
            onBlurRef.current = true;
            return;
        }
        default:
            return;
        }
    };
    const onChangeTenure = (id, data) => {
        onCalculatorUsed();
        setInputParameters({ ...inputParameters, loanTenure: data.value });
        setPriceState({ ...priceState, loanTenure: data.value });
        handleSI({...inputParameters, loanTenure: data.value});
    };
    // const handlePreApproval = async () => {
    //     setRedirectRouteConnect(history.location.pathname);
    //     setPreApprovedOriginConnect(CAR_LIST_EVENT_NAMES.DETAILS);
    //     await yieldToMain();
    //     trackDesktopCustomEventsAU(EVENT_CONSTANTS.LOAN_CALCULATOR_CDP_ACTION, EVENT_DATA.LOAN_CALCULATOR_CDP_ACTION);
    //     history.push("/financing/get-pre-approval");
    // };

    const toggleLoanDetailsAccordion = () => {
        setLoanDetailsAccordion(!loanDetailsAccordion);
    };

    const handlePreApproval = () => {
        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.FF_VOLUME_EXPERIMENT, {
            eventCategory: "FF_volume_experiment",
            eventAction: "Loan_calculator_CDP_action",
            eventLabel: "{{Calculator_CDP_get_pre_approval_clicked}}",
            event: "custom_event"
        });

        const isPreApprovalOnFlyVariant = getAbExpirementVariant(
            preApprovalOnFlyDesktop,
            EXPERIMENT_TYPE.VARIANT_B
        );

        if (isPreApprovalOnFlyVariant && startPreApprovalOnFlyConnect) {
            startPreApprovalOnFlyConnect({ entryPoint: "cdp-loan-calculator", ctaText: "Continue Booking", refetchOnClose: true });
        } else {
            history.push("/financing/get-pre-approval");
        }
    };

    return (
        <div styleName={"styles.calculatorWrapper"}>
            <div styleName={"styles.leftPanel"}>
                <div styleName={"styles.headingWrapper"}>
                    <p styleName={"styles.leftPanelHeading"}>Car loan calculator</p>
                    <span styleName={"styles.bestRatesStrip"}>Best interest rates</span>
                </div>
                <div styleName={"styles.carPriceWrapper"}>
                    <div styleName={"styles.tenureWrap"}>
                        <p styleName={"styles.label"}>Car price</p>
                        <p styleName={"styles.carPrice"}>{makePriceLabelRound(inputParameters.dap)}</p>
                    </div>
                </div>
                <div styleName={"styles.tenureDepositWrap"}>
                    <div styleName={"styles.tenureWrap"}>
                        <p styleName={"styles.suffix"}>Loan term</p>
                        <Search
                            placeholder="Select term"
                            data={DEFAULT_TENURE}
                            onChange={(data) => onChangeTenure("tenure", {value: data.value, label: data.label})}
                            value={inputParameters.loanTenure ? {label: inputParameters.loanTenure, value: inputParameters.loanTenure} : ""}
                        />
                    </div>
                    <div styleName={"styles.depositWrap"}>
                        <p styleName={"styles.suffix"}>Deposit</p>
                        <InputText
                            // readOnly={true}
                            id={FINANCE_CALCULATOR.DEPOSIT}
                            // styleName="styles.price"
                            onChange={(e) => onChange(FINANCE_CALCULATOR.DEPOSIT, e)}
                            onBlurCallback={onBlurInput}
                            value={inputParameters.deposit}
                            onlyNumber={true}
                            onFocusCallback={onCalculatorUsed}
                        />
                    </div>
                    <div styleName={"styles.interestWrap"}>
                        <p styleName={"styles.suffix"}>Interest rate</p>
                        <InputText
                            // readOnly={true}
                            type="text"
                            id={FINANCE_CALCULATOR.INTEREST}
                            // styleName="styles.price"
                            onChange={(e) => onChange(FINANCE_CALCULATOR.INTEREST, e)}
                            value={inputParameters.interestRate}
                            // onlyNumber={true}
                            onBlurCallback={onBlurInput}
                            onFocusCallback={onCalculatorUsed}
                        />
                    </div>
                    {!preApproved &&
                    <div styleName={"styles.priceSliderContainer"}>
                        <p styleName={"styles.loanMinValue"}>{minRate}%</p>
                        <Slider {...interestSlider} />
                        <p styleName={"styles.loanMaxValue"}>{maxRate}%</p>
                    </div>}
                </div>
                {showStrip && (
                    <div styleName={isWithinLimit ? "styles.successBanner" : "styles.warningBanner"}>
                        <div styleName={"styles.bannerIcon"}>
                            {isWithinLimit ? <img src={SuccessIcon} alt="success" /> : <img src={WarningIcon} alt="warning" />}
                        </div>
                        <p styleName={"styles.bannerText"}>
                            {isWithinLimit
                                ? "Great! The repayment estimate is within your Pre-approved limit."
                                : "Oops! The repayment estimate is greater than your Pre-approved limit."}
                        </p>
                    </div>
                )}
            </div>
            <div styleName={"styles.rightPanelWrapper"}>
                {showStrip && <div styleName={"styles.topStrip"}>
                    <p styleName={"styles.stripText"}>You're pre-approved for finance upto {getPreApprovedAmount(null, maxPermissibleRepaymentPerWeek)}</p>
                </div>}
                <div styleName={"styles.rightPanel"}>

                    <p styleName={"styles.estimatedHeading"}>Your estimated repayments</p>
                    <div styleName={`styles.tabWrapper`} >
                        {REPAYMENT_TENURE_TABS.map((tab) => (
                            <p styleName={`styles.tab ${activeTab.key === tab.key ? "styles.tabActive" : ""}`} onClick={() => setActiveTab(tab)}>
                                {tab.label}
                            </p>
                        ))}
                    </div>
                    <div styleName={"styles.repaymentAmountWrap"}>
                        <div styleName={"styles.graphWraper"} >
                            <GuageChart percentage={graphPercentage} />
                        </div>
                        <div styleName={"styles.textWrapper"}>
                            <p styleName={"styles.mainAmount"}>{makePriceLabelRound(repaymentSI[activeTab.key])}</p>
                            <p styleName={"styles.perMonth"}>per {activeTab.shorthand}</p>
                            <p styleName={"styles.repayment"}>repayment @ {priceState.interestRate}% p.a.</p>
                        </div>
                    </div>
                    <div styleName={"styles.loanDetailsWrap"}>
                        <div styleName={"styles.loanDetailsAccordion"}>
                            <p styleName={"styles.loanDetailsAccordionTitle"}>Loan details</p>
                            <img src={DropDown} onClick={toggleLoanDetailsAccordion} style={{ cursor: "pointer", transform: loanDetailsAccordion ? "rotate(180deg)" : "rotate(0deg)" }} />
                        </div>
                        {loanDetailsAccordion && <div styleName={"styles.totalPriceWrapper"}>
                            <div styleName={"styles.amountWrapper"}>
                                <p styleName={"styles.loanAmount"}>Loan amount</p>
                                <p styleName={"styles.amount"}>{makePriceLabelRound(totalLoanAmount)}</p>
                            </div>
                            <div styleName={"styles.amountWrapper"}>
                                <p styleName={"styles.interestAmount"}>
                                        Interest amount <span>@ {priceState.interestRate}% p.a.</span>
                                </p>
                                <p styleName={"styles.amount"}>{makePriceLabelRound(totalAmountPaid[activeTab.key] - totalLoanAmount)}</p>
                            </div>
                            <div styleName={"styles.totalAmount"}>
                                <p styleName={"styles.total"}>Total amount</p>
                                <p styleName={"styles.total"}>{makePriceLabelRound(totalAmountPaid[activeTab.key])}</p>
                            </div>
                        </div>}
                    </div>
                    {!preApproved && <div styleName="styles.actionButtonWrapper"><Button text="Get pre-approval" onClick={handlePreApproval} rightImage={ArrowRight} rightImageStyle="right-image" /></div>}
                    {/* <p styleName={"styles.getCallBack"} onClick={handleCallbackRequest}><img src={phoneIcon} />Get call back from Cars 24 Finance Expert</p> */}
                    <p styleName={"styles.termsCondition"}>If you find a lower rate, we'll match it as well as contribute <span styleName={"styles.deposit"}>$300 towards your deposit.</span>
                        <span>
                            <a styleName={"styles.underline"} href={FINANCE_TNC_LINK} target="_blank">T&C apply</a>
                        </span>
                    </p>
                </div>
            </div>

        </div>
    );
};
CdpLoanCalculator.propTypes = {
    content: PropTypes.object.isRequired,
    preApproved: PropTypes.bool.isRequired,
    ctaProps: PropTypes.object.isRequired,
    setRedirectRouteConnect: PropTypes.func.isRequired,
    minMaxInterestRateInfo: PropTypes.object.isRequired,
    getMinMaxInterestRatesConnect: PropTypes.func.isRequired,
    loanCalculatorInfo: PropTypes.object.isRequired,
    stEligibleData: PropTypes.object.isRequired,
    setPreApprovedOriginConnect: PropTypes.func.isRequired,
    handleCallbackRequest: PropTypes.func.isRequired,
    maxPermissibleRepaymentPerWeek: PropTypes.number,
    isPurposeBusiness: PropTypes.string,
    startPreApprovalOnFlyConnect: PropTypes.func,
    preApprovalOnFlyDesktop: PropTypes.object
};
export default withCallbackRequest(CdpLoanCalculator);
